module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_signalnco.e2b878bb0c4a44cf75a9fef7ec53e46f.png";